<template>
  <div v-if="account" style="padding-left: 20px; padding-right: 20px" class="mobileContainer">
    <div v-if="!global_load">
      <div style="background-color: #fff; width: 100%" class="noPrint">
        <v-row align="center">
          <v-col cols="auto">
            <v-icon icon="mdi-chevron-left" @click="goHome()" style="font-size: 32px"></v-icon>
          </v-col>
          <v-col cols="auto">
            <h6>{{ logbookDetail.name || "Logbook name" }}</h6>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" style="padding-bottom: 0px !important" class="filters">
            <div style="display: flex; gap: 20px; align-items: center; margin-right: 20px" class="filtersContainer">
              <v-text-field class="logbookMobileFilter" style="width: 220px" label="Select date" readonly variant="solo"
                persistentPlaceholder :value="selectedDate ? selectedDate.toLocaleDateString() : 'TODAY'">
                <template #append-inner>
                  <v-btn icon flat class="calendarIcon"><v-icon>mdi-calendar</v-icon>
                    <v-menu activator="parent">
                      <v-date-picker
                        hideHeader
                        first-day-of-week="1"
                        v-model="selectedDate"
                        @update:modelValue="updateShiftAndFetch()"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-btn>
                </template>
              </v-text-field>
              <v-select class="logbookMobileFilter" label="Select shift" :items="weekday > 4 ? weekendShifts : shifts"
                item-value="value" item-title="name" variant="solo" style="width: 160px" v-model="selectedShift"
                return-object @update:modelValue="getCurrent(selectedShift)"></v-select>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="noPrint" style="background-color: #fff; padding: 10px; margin-top: 25px">
        <div style="width: 100%; text-align: center">
          <h6>{{ errorSelectedShift.status }}</h6>
        </div>
        <v-tabs v-model="tab" align-tabs="center" bg-color="#fff" stacked fixed-tabs>
          <v-tab :value="new Date(item).getUTCHours()" v-for="(key, item) in currentShift" :key="key"
            @click="disableEdit()">
            {{ new Date(item).getHours() }} -
            {{ new Date(item).getHours() + 1 }}
            <div>
              <!-- Display checkboxes dynamically based on `hourlyCompletionStatus` -->
              <v-icon v-if="hourlyCompletionStatus[item] === 'empty'" icon="mdi-check-circle-outline"
                color="grey"></v-icon>
              <v-icon v-if="hourlyCompletionStatus[item] === 'empty'" icon="mdi-check-circle-outline"
                color="grey"></v-icon>
              <v-icon v-if="hourlyCompletionStatus[item] === 'partial'" icon="mdi-check-circle-outline"
                color="green"></v-icon>
              <v-icon v-if="hourlyCompletionStatus[item] === 'partial'" icon="mdi-check-circle-outline"
                color="grey"></v-icon>
              <v-icon v-if="hourlyCompletionStatus[item] === 'full'" icon="mdi-check-circle-outline"
                color="green"></v-icon>
              <v-icon v-if="hourlyCompletionStatus[item] === 'full'" icon="mdi-check-circle-outline"
                color="green"></v-icon>
            </div>
          </v-tab>
        </v-tabs>
      </div>
      <v-tabs-window v-model="tab">
        <v-tabs-window-item :value="new Date(hourValue).getUTCHours()" v-for="(key, hourValue) in currentShift"
          :key="key">
          <div style="margin-top: 15px; width: 100%; background-color: #fff; padding: 10px"
            v-for="(processCell, key1) in key" :key="key1" v-show="!lineWithMachineHidden[key1]">
            <h6 style="font-size: 16px; margin-bottom: 16px;">{{ key1 }}</h6>

            <v-row v-for="(processCellFact, rowIndex) in processCell.facts" :key="rowIndex" class="pc-row">
              <v-col cols="2" style="flex-wrap: wrap;align-content: center;padding-top: 2px;
                                      padding-bottom: 2px; display: flex;" class="mobileCol">
                <div style="width: 240px" class="bigHeader">
                  <v-list-item style="padding-top: 0px !important">
                    <template v-slot:title>
                      <span style="font-weight: bold; font-size: 12px">{{ processCellFact.line }}</span>
                    </template>

                    <template v-slot:subtitle>
                      <v-list-item-title style="font-size: 12px">Target: {{ processCellFact.target
                        }}</v-list-item-title>
                      <v-list-item-title style="font-size: 12px">Actual: {{ processCellFact.actual
                        }}</v-list-item-title>
                    </template>
                  </v-list-item>
                </div>
              </v-col>
              <v-col style="flex-wrap: wrap; display: flex; align-content: center">
                <template v-for="(customItemFromList, key) in customFieldList" :key="customItemFromList">
                  <v-row style="min-height: 48px !important" v-if="processCell.process_cell_id == key">
                    <template v-if="processCell.process_cell_id == key">
                      <v-col cols="auto" v-for="customFieldItem in customItemFromList.customFields"
                        :key="customFieldItem" style="
                                          display: flex;
                                          width: 18vw;
                                          padding: 0px !important;
                                          align-content: center;
                                          flex-wrap: wrap;
                                          margin-bottom: 5px;
                                          margin-top: 5px;
                                          margin-right: 5px;" class="mobileInputs" @click="enableEdit(rowIndex, customFieldItem.name, this.getLastFactForCustomField(processCellFact, customFieldItem.id)? this.getLastFactForCustomField(processCellFact, customFieldItem.id).value : '')">
                          <span v-if="editCell.row === rowIndex && editCell.field === customFieldItem.name && processCell.process_cell_id == key">
                            <span v-if="customFieldItem.data_type == 'string'">
                              <v-text-field v-model="pcValue" id="nowedit" ref="myField" bg-color="white"
                                density="compact" light :label="customFieldItem.name" hide-details variant="outlined"
                                style="width: 18vw; padding: 2px" @keydown.enter="
                                  fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, true)
                                  "
                                @blur="fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false); editCell.cell = null">
                                <template v-slot:append-inner>
                                  <v-btn v-show="editCell.cell !== null" variant="text" icon @click="
                                    fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false)
                                    ">
                                    <v-icon>mdi-check</v-icon></v-btn>
                                </template>
                              </v-text-field>
                            </span>
                            <span v-if="customFieldItem.data_type == 'int' || customFieldItem.data_type == 'float'">
                              <v-text-field style="width: 18vw; padding: 2px" bg-color="white" variant="outlined"
                                :label="customFieldItem.name" v-model="pcValue" id="nowedit" ref="myField"
                                density="compact" light hide-details @keydown.enter="
                                  fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, true)
                                  "
                                @blur="fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false); editCell.cell = null"
                                type="number">
                                <template v-slot:append-inner>
                                  <v-btn v-show="editCell.cell !== null" variant="text" icon @click="
                                    fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false)
                                    ">
                                    <v-icon>mdi-check</v-icon></v-btn>
                                </template>
                              </v-text-field>
                            </span>
                            <span v-if="customFieldItem.data_type == 'bool'">
                              <v-select style="width: 18vw; padding: 2px" density="compact" light hide-details
                                bg-color="white" variant="outlined" :label="customFieldItem.name" :items="boolField"
                                item-title="name" item-value="value" v-model="pcValue" @keydown.enter="
                                  fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, true)
                                  "
                                @blur="fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false); editCell.cell = null">
                                <template v-slot:append-inner>
                                  <v-btn v-show="editCell.cell !== null" variant="text" icon @click="
                                    fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false)
                                    ">
                                    <v-icon>mdi-check</v-icon></v-btn>
                                </template>
                              </v-select>
                            </span>
                            <span v-if="customFieldItem.data_type == 'choices'">
                              <v-select style="width: 18vw; padding: 2px" :items="customFieldItem.options" :label="customFieldItem.name"
                                item-title="value" item-value="value" light hide-details
                                bg-color="white" variant="outlined" density="compact" v-model="pcValue" @keydown.enter="
                                  fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, true)
                                  "
                                @blur="fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false); editCell.cell = null">
                                <template v-slot:append-inner>
                                  <v-btn v-show="editCell.cell !== null" variant="text" icon @click="
                                    fillProcessCell(processCellFact, customFieldItem.id, pcValue, processCell.process_cell_id, false)
                                    ">
                                    <v-icon>mdi-check</v-icon></v-btn>
                                </template>
                              </v-select>
                            </span>
                          </span>
                          <span v-else>

                            <template v-if="!this.getLastFactForCustomField(processCellFact, customFieldItem.id)">
                              <v-text-field 
                                hide-details bg-color="white" density="compact" light
                                :placeholder="customFieldItem.name" variant="outlined" style="width: 18vw;">
                              </v-text-field>
                            </template>
                            <template
                              v-else-if="getLastFactForCustomField(processCellFact, customFieldItem.id).loading">
                              <v-text-field hide-details bg-color="white" density="compact" light
                               variant="outlined" style="width: 18vw;">
                                <template v-slot:append-inner>
                                  <v-progress-circular
                                    v-show="getLastFactForCustomField(processCellFact, customFieldItem.id).loading"
                                    color="green" indeterminate></v-progress-circular>
                                </template>
                              </v-text-field>
                            </template>
                            <template v-else>

                              <v-text-field  hide-details bg-color="white" density="compact" light
                                :label="customFieldItem.name" variant="outlined" style="width: 18vw;"
                                v-model="this.getLastFactForCustomField(processCellFact, customFieldItem.id).value">
                              </v-text-field>
                            </template>
                          </span>
                      </v-col>
                    </template>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </div>
          <v-divider style="margin-top: 1vh; margin-bottom: 1vh" class="noPrint"></v-divider>
          <div>
            <div v-for="(a, b) in octabularasa[tab]" :key="b"
              style="margin-top: 15px; width: 100%; background-color: #fff; padding: 10px" class="bigContainerToPrint">
              <h6 class="mb-4" style="font-size: 16px">
                {{ b }} - Machines
              </h6>
              <div class="mt-2" v-for="fact in a.facts" :key="fact.id">
                <div
                  v-for="machine in fact.machines.toSorted((x, y) => { logbookDetail.ordering.mc[y] - logbookDetail.ordering.mc[x] })"
                  :key="machine.id" style="" class="machine-row">
                  <div v-for="machine_fact in machine.machine_facts" :key="machine_fact.id">
                    <div class="printMachinesFacts" style="padding: 0px">
                      <v-col :cols="4" style="padding: 0px; display: flex; align-content: center; flex-wrap: wrap">
                        <h6 style="font-size: 13px !important; margin-left: 15px">
                          {{ machine.name }} {{ machine.unit }}
                        </h6>
                      </v-col>
                      <v-col class="" style="padding: 0px">
                        <v-row style="padding-bottom: 0px" no-gutters class="">
                          <v-col style="padding-bottom: 0px" :cols="machine_fact.machine_custom_field_facts.length === 2
                            ? 6
                            : machine_fact.machine_custom_field_facts.length === 1
                              ? 6
                              : 4
                            "
                            v-for="mcf in machine_fact.machine_custom_field_facts.toSorted((x, y) => { logbookDetail.ordering.mcf[y] - logbookDetail.ordering.mcf[x] })"
                            :key="mcf.id">
                            <v-list-item style="padding-top: 0px !important; padding-bottom: 0px !important">
                              <h6 style="font-size: 13px !important">
                                <span style="font-weight: 100">{{ mcf.field_type }}</span>
                                : <span>{{ mcf.value || "----" }}</span>
                              </h6>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-col>
                    </div>
                    <!-- TEST FOR PRINTING MACHINE FACTS -->
                    <div class="machine-custom-fields" style="padding-top: 15px; padding-bottom: 15px">
                      <v-row class="machine-custom-fields" style="min-height: 48px !important">
                        <v-col cols="2" style="
                                      flex-wrap: wrap;
                                      align-content: center;
                                      padding-top: 2px;
                                      padding-bottom: 2px;
                                      display: flex;
                                    " class="mobileCol">
                          <div style="width: 240px" class="bigHeader">
                            <v-list-item style="padding-top: 0px !important">
                              <template v-slot:title>
                                <span style="font-weight: bold; font-size: 12px">{{ machine.name }}</span>
                              </template>

                    <template v-slot:subtitle>
                      <v-list-item-title style="font-size: 12px"> {{ machine.unit }}</v-list-item-title>
                    </template>
                  </v-list-item>
                </div>
                <h6 class="mb-2 mt-2 ms-2 text-medium-emphasis mobileHeader">
                  {{ machine.name }} -- {{ machine.unit }}
                </h6>
              </v-col>
              <v-col style="flex-wrap: wrap; display: flex; align-content: center">
                <v-row style="min-height: 48px !important">
                  <v-col cols="auto" v-for="mcf in machine_fact.machine_custom_field_facts" :key="mcf.id" style="
                                display: flex;
                                width: 18vw;
                                padding: 0px !important;
                                align-content: center;
                                flex-wrap: wrap;
                              " class="mobileInputs">
                    <span v-if="mcf.data_type == 'string'">
                      <v-text-field hide-details bg-color="white" density="compact" light :label="mcf.field_type"
                        variant="outlined" @focus="this.selectedmcf = mcf" @blur="
                          setMachineCustomField(machine.id, mcf, fact.id);
                        this.selectedmcf = null;
                        " @keydown.enter="setMachineCustomField(machine.id, mcf, fact.id)" v-model="mcf.value"
                        style="width: 18vw; padding: 2px" clearable class="mobileInputs">
                        <template v-slot:prepend-inner>
                          <v-progress-circular v-show="mcf.loading" color="green" indeterminate></v-progress-circular>
                        </template>
                      </v-text-field>
                    </span>
                    <span v-if="mcf.data_type == 'choices'">
                      <v-select hide-details bg-color="white" density="compact" light :label="mcf.field_type"
                        :items="mcf.options" variant="outlined" @focus="this.selectedmcf = mcf" @blur="
                          setMachineCustomField(machine.id, mcf, fact.id);
                        this.selectedmcf = null;
                        " @keydown.enter="setMachineCustomField(machine.id, mcf, fact.id)" v-model="mcf.value"
                        style="width: 18vw; padding: 2px" class="mobileInputs">
                        <template v-slot:prepend-inner>
                          <v-progress-circular v-show="mcf.loading" color="green" indeterminate></v-progress-circular>
                        </template>
                      </v-select>
                    </span>
                    <span v-if="mcf.data_type == 'int' || mcf.data_type == 'float'">
                      <v-text-field hide-details bg-color="white" density="compact" :label="mcf.field_type"
                        variant="outlined" @focus="this.selectedmcf = mcf" @blur="
                          setMachineCustomField(machine.id, mcf, fact.id);
                        this.selectedmcf = null;
                        " @keydown.enter="setMachineCustomField(machine.id, mcf, fact.id)" v-model="mcf.value"
                        style="width: 18vw; padding: 2px" clearable type="number" class="mobileInputs">
                        <template v-slot:prepend-inner>
                          <v-progress-circular v-show="mcf.loading" color="green" indeterminate></v-progress-circular>
                        </template>
                      </v-text-field>
                    </span>

                    <span v-if="mcf.data_type == 'bool'">
                      <v-select hide-details bg-color="white" clearable density="compact" light :label="mcf.field_type" :items="boolField"
                        item-title="name" item-value="value" v-model="mcf.value" @focus="this.selectedmcf = mcf"
                        @blur="setMachineCustomField(machine.id, mcf, fact.id); this.selectedmcf = null"
                        @keydown.enter="setMachineCustomField(machine.id, mcf, fact.id)"
                        style="width: 18vw; padding: 2px" class="mobileInputs" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-progress-circular v-show="mcf.loading" color="green" indeterminate></v-progress-circular>
                        </template>
                      </v-select>
                    </span>
                    <span v-if="mcf.data_type == 'percentage'">
                      <v-text-field hide-details bg-color="white" density="compact" light :label="mcf.field_type"
                        variant="outlined" @focus="this.selectedmcf = mcf" @blur="
                          setMachineCustomField(machine.id, mcf, fact.id);
                        this.selectedmcf = null;
                        " @keydown.enter="setMachineCustomField(machine.id, mcf, fact.id)" v-model="mcf.value"
                        style="width: 18vw; padding: 2px" class="mobileInputs" type="number">
                        <template v-slot:prepend-inner>
                          <v-progress-circular v-show="mcf.loading" color="green" indeterminate></v-progress-circular>
                        </template>
                      </v-text-field>
                    </span>
                    <span v-if="mcf.data_type == 'datetime'">
                      <v-text-field hide-details bg-color="white" density="compact" light :label="mcf.field_type"
                        variant="outlined" @focus="this.selectedmcf = mcf" @blur="
                          setMachineCustomField(machine.id, mcf, fact.id);
                        this.selectedmcf = null;" 
                        @keydown.enter="setMachineCustomField(machine.id, mcf, fact.id)" v-model="mcf.value"
                        style="width: 18vw" class="mobileInputs" type="datetime-local">
                        <template v-slot:prepend-inner>
                          <v-progress-circular v-show="mcf.loading" color="green" indeterminate>

                          </v-progress-circular>
                        </template>
                      </v-text-field>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <v-divider class="noPrint"></v-divider>
        </div>
      </div>
    </div>
  </div>
</div>
<v-snackbar v-model="snackbar.showing" :timeout="timeout" :color="snackbar.ok ? 'green' : 'red'">
  <div style="text-align: center">
    {{ snackbar.text }}
  </div>
</v-snackbar>
</v-tabs-window-item>
</v-tabs-window>
</div>
<div v-else style="display: flex">
  <span style="margin: auto">
    <v-progress-circular color="green" indeterminate></v-progress-circular>
  </span>
</div>
</div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    let shifts = [
      { name: "Morning shift", value: "morning", start: 6 },
      { name: "Day shift", value: "day", start: 14 },
      { name: "Night shift", value: "night", start: 22 },
    ];
    let weekendShifts = [
      { name: "Long morning shift", value: "morning", start: 6 },
      { name: "Long night shift", value: "night", start: 18 },
    ];
    let now_hours = new Date().getUTCHours();
    let weekDay = new Date().getDay();

    return {
      weekday: weekDay,
      global_load: true,
      account: undefined,
      timeout: 5000,
      logbooks: [],
      currentShift: [],
      octabularasa: {},
      isLoadingLineFact: false,
      idParam: null,
      logbookDetail: [],
      tab: now_hours,
      editCell: { row: null, field: null },
      fieldTypes: [
        { name: "String", value: "string" },
        { name: "Number", value: "int" },
        { name: "Decimal", value: "float" },
        { name: "True/False", value: "bool" },
      ],
      boolField: [
        { name: "Yes", value: "true" },
        { name: "No", value: "false" },
      ],
      shifts: shifts,
      weekendShifts: weekendShifts,
      selectedShift: (21 < now_hours) | (now_hours <= 6) ? shifts[2] : now_hours >= 14 ? shifts[1] : shifts[0],
      errorSelectedShift: "",
      selectedDate: null,
      fromDate: "",
      toDate: "",
      customFieldList: [],
      activeCustomField: true,
      customFieldName: "",
      type: "",
      pcValue: null,
      snackbar: { text: "default", ok: true, showing: false },
      selectedmcf: null,
      lineWithMachineHidden: {},
      hasEdits: false,
      allFieldsCompleted: false,
    };
  },
  created() {
    var urlParam = this.$route.params.id;
    this.idParam = urlParam;
    const msalApp = window.msalApp;
    this.account = msalApp.getActiveAccount();
  },
  async mounted() {
    await this.getLogbookDetail();
    await this.getCurrent(this.selectedShift);


    // this.getLogbookDetail().then(() => {
    //     this.global_load = false;
    // });
  },
  methods: {
    /*
     * Processes the logBookDetail object to group custom fields by process cell ID.
     *
     * @param {Object} logBookDetail - The log book detail object containing lines with process cells and custom fields.
     * @param {Array} logBookDetail.lines - Array of line objects.
     * @param {Object} logBookDetail.lines[].process_cell - The process cell object.
     * @param {number} logBookDetail.lines[].process_cell.id - The ID of the process cell.
     * @param {Array} logBookDetail.lines[].combined_custom_fields - Array of custom field objects.
     * @param {number} logBookDetail.lines[].combined_custom_fields[].id - The ID of the custom field.
     *
     * @returns {void} - This function does not return a value. It updates the customFieldList property of the component.
     */
    processCellList(logBookDetail) {
      var lines = logBookDetail.lines;
      let groupedItems = {};

      for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        let id = line.process_cell.id;
        if (!groupedItems[id]) {
          groupedItems[id] = {
            id: id,
            customFields: [],
          };
        }
        let existingFields = new Set(groupedItems[id].customFields.map((field) => field.id));

        line.combined_custom_fields.forEach((field) => {
          if (!existingFields.has(field.id)) {
            groupedItems[id].customFields.push(field);
            existingFields.add(field.id);
          }
        });
      }

      this.customFieldList = groupedItems;

      const orderingCf = this.logbookDetail.ordering.cf;

      // Sort the customFieldList based on the ordering
      const customFieldArray = Object.entries(this.customFieldList).map(([id, value]) => ({ id, ...value }));


      customFieldArray.forEach(item => {
        if (item !== null) {
          item.customFields.sort((a, b) => {
            return orderingCf[a.id] - orderingCf[b.id];
          });
        }
      })

    },
    /*
     * Method to handle the loss of focus on a specific field.
     * If the reference to the field (`myField`) exists and is an array with at least one element,
     * it triggers the blur event on the first element of the array.
     */
    lostFocus() {
      if (this.$refs.myField && this.$refs.myField[0]) {
        this.$refs.myField[0].blur();
      }
    },
    focusDelayed() {
      setTimeout(() => {
        let elemente = document.getElementById("nowedit");
        if (elemente) {
          elemente.focus();
        }
      }, 25);
    },
    /*
     * Enables editing for a specific cell in the logbook.
     *
     * @param {number} rowIndex - The index of the row containing the cell to be edited.
     * @param {string} field - The field name of the cell to be edited.
     * @param {string} initialValue - The initial value of the cell to be edited.
     */
    enableEdit(rowIndex, field, initialValue) {
      this.editCell = { row: rowIndex, field, value: initialValue };
      this.pcValue = initialValue || "";
      this.focusDelayed();

      console.log(rowIndex, field, initialValue);
      console.log(this.editCell);


    },
    disableEdit() {
      this.editCell = { row: null, field: null, value: null };
    },
    /*
     * Retrieves the last fact for a given custom field from the provided ibox object.
     *
     * @param {Object} ibox - The ibox object containing custom field facts.
     * @param {Number} customFieldId - The ID of the custom field to retrieve the last fact for.
     * @returns {Object|null} - The last fact object for the specified custom field,     null if no facts are found.
     */
    getLastFactForCustomField(ibox, customFieldId) {
      let filtered = ibox.custom_field_facts.filter((o) => o.field_type_obj.id === customFieldId);
      if (filtered.length > 0) {
        return filtered[filtered.length - 1];
      } else {
        return null;
      }
    },
    sNack(msg, ok) {
      this.snackbar.text = msg;
      this.snackbar.ok = ok;
      this.snackbar.showing = true;
    },
    /*
     * Fills a process cell with a custom field value.
     *
     * @param {Object} processCellFact - The logbook line fact object containing custom field facts.
     * @param {Number} customFieldId - The ID of the custom field to be filled.
     * @param {String|Number} value - The value to be set for the custom field.
     * @param {Number} pcId - The ID of the process cell.
     * @param {Boolean} reality_shift - A flag indicating if the reality shift is active.
     *
     * @returns {void}
     *
     * This method checks if the provided value is not null or an empty string. If the value is valid, it retrieves the last fact for the custom field.
     * If the retrieved fact's value is different from the provided value, it updates the fact's value and sends a POST request to update the custom field.
     * If the fact's value is the same as the provided value, it does nothing.
     * If no fact is found, it creates a new custom field fact, adds it to the processCellFact, and sends a POST request to add the custom field.
     *
     * On successful update or addition, it displays a success message. On failure, it displays an error message.
     */
    fillProcessCell(processCellFact, customFieldId, value, pcId, reality_shift) {
      if (value == null) {
        return;
      } else if (value == "") {
        return;
      }
      let reducto = this.getLastFactForCustomField(processCellFact, customFieldId);
      if (reducto != undefined) {
        if (reducto.value != value) {
          reducto.value = value;
          reducto.loading = true;
          axios
            .post("/apiv1/pcf/pcf-fill", {
              process_cell: pcId,
              custom_field: customFieldId,
              logbook_line_fact: processCellFact.id,
              value: value,
            })
            .then((res) => {
              reducto.loading = false;
              if (res.status == 200 && res.data) {
                this.sNack("Custom field updated", true);
                reducto.value = res.data.value;
              }
            })
            .catch((err) => {
              this.sNack(err.response.data, false);
            });
        } else {
          return;
        }
      } else {
        let obj = {
          field_type_obj: { id: customFieldId },
          value: value,
          loading: true,
        };
        processCellFact.custom_field_facts.push(obj);
        axios
          .post("/apiv1/pcf/pcf-fill", {
            process_cell: pcId,
            custom_field: customFieldId,
            logbook_line_fact: processCellFact.id,
            value: value,
          })
          .then((res) => {
            if (res.status == 200 && res.data) {
              this.sNack("Custom field added", true);
              obj = res.data;
            }
          })
          .catch((err) => {
            console.log(err.response.data);
            this.sNack(err.response.data, false);
          });
      }
      this.pcValue = null;
      if (reality_shift) {
        this.disableEdit();
      } else {
        // TODO: FUNGAL SHIFT TO THE NEST PARALLEL UNIVERSE (swap to next cell)
        this.editCell = { row: null, field: null, value: null };
      }
    },
    goHome() {
      this.$router.push("/");
    },
    /**
     * Fetches and processes the current shift data based on the provided shift and selected date.
     *
     * @param {Object} shift - The shift object containing the start time.
     *
     * This method performs the following steps:
     * 1. Initializes the current shift data, error message, and loading state.
     * 2. Determines the date range (`fromDate` and `toDate`) based on the current date or the selected date.
     *    - If no date is selected, it uses the current date and adjusts the range based on the shift start time.
     *    - If a date is selected, it uses the selected date and adjusts the range based on the shift start time.
     * 3. Makes an API call to fetch the shift data within the determined date range.
     * 4. Processes the fetched data:
     *    - Sorts the data by date.
     *    - Reassigns the sorted data to the `currentShift` object.
     *    - Maps the data to a new object `octabularasa` with hours as keys.
     * 5. Updates the loading state and handles any errors that occur during the API call.
     */
    async getCurrent(shift) {
      this.currentShift = [];
      this.errorSelectedShift = "";
      this.isLoadingLineFact = true;
      this.global_load = true;
      if (!this.selectedDate) {
        if (this.weekday <= 4) {
          let now = new Date();
          let fromz = now.getUTCHours() < 7 ? new Date(now.getTime() - 24 * 60 * 60 * 1000) : now;
          fromz.setHours(shift.start);
          let toz = new Date(fromz);
          toz.setHours(fromz.getHours() + 7);
          this.fromDate = fromz.toISOString();
          this.toDate = toz.toISOString();
        } else {
          let now = new Date();
          let fromz = now.getUTCHours() < 7 ? new Date(now.getTime() - 24 * 60 * 60 * 1000) : now;
          fromz.setHours(shift.start);
          let toz = new Date(fromz);
          toz.setHours(fromz.getHours() + 11);
          // console.log(toz.setHours(fromz.getHours() + 12));
          this.fromDate = fromz.toISOString();
          this.toDate = toz.toISOString();
        }
      } else {
        if (this.weekday <= 4) {
          let not_now = new Date(this.selectedDate);
          let fromz = not_now.getUTCHours < 7 ? not_now : not_now;
          fromz.setHours(shift.start);
          let toz = new Date(fromz);
          toz.setHours(fromz.getHours() + 7);
          this.fromDate = fromz.toISOString();
          this.toDate = toz.toISOString();
        } else {
          let not_now = new Date(this.selectedDate);
          let fromz = not_now.getUTCHours < 7 ? not_now : not_now;
          fromz.setHours(shift.start);
          let toz = new Date(fromz);
          toz.setHours(fromz.getHours() + 11);
          this.fromDate = fromz.toISOString();
          this.toDate = toz.toISOString();
          console.log(fromz.toISOString(), toz.toISOString());
        }
      }

      await axios
        .get(`/apiv1/${this.idParam}/final-enriched-nested-tree?fbs=F1&from=${this.fromDate}&to=${this.toDate}`)
        .then((res) => {
          this.currentShift = res.data.linefacts;
          this.lineWithMachine = res.data.lines_with_machines;
          this.weekday = new Date(this.fromDate).getDay();


          console.log(res.data);


          Object.entries(this.currentShift).forEach((key) => {
            // console.log('key',key);
            Object.entries(key[1]).forEach((key2) => {
              // console.log('key2',key2);
              Object.entries(key2[1].facts).forEach((key3) => {
                if (Array.isArray(key3[1].machines)) {
                  key3[1].machines.sort((a, b) => {
                    const orderingMc = this.logbookDetail.ordering.mc;
                    return orderingMc[a.id] - orderingMc[b.id];
                  });
                }
                Object.entries(key3[1].machines).forEach((key4) => {
                  // console.log('key4',key4);
                  Object.entries(key4[1].machine_facts).forEach((key5) => {
                    // console.log('key5',key5[1]);
                    if (Array.isArray(key5[1].machine_custom_field_facts)) {
                      key5[1].machine_custom_field_facts.sort((a, b) => {
                        const orderingMcf = this.logbookDetail.ordering.mcf;
                        return orderingMcf[a.field_type_id] - orderingMcf[b.field_type_id];
                      });
                    }
                  });
                });
              });
            });

            const orderingPc = this.logbookDetail.ordering.pc;
            const sortedEntries = Object.entries(key[1]).sort((a, b) => {
              return orderingPc[a[1].process_cell_id] - orderingPc[b[1].process_cell_id];
            });

            this.currentShift[key[0]] = Object.fromEntries(sortedEntries);
          });
        })
        .catch((err) => {
          this.errorSelectedShift = err.response.data;
          this.isLoadingLineFact = false;
          this.global_load = false;
        })
        .then(() => {
          this.octabularasa = {};
          Object.entries(this.currentShift)
            .sort((a, b) => new Date(a[0]) - new Date(b[0]))
            .forEach(([key, value]) => {
              delete this.currentShift[key]; //remove old key-value
              this.currentShift[key] = value;
            });
          // console.log('after_____', this.currentShift);
          Object.entries(this.currentShift).forEach(([key, value]) => {
            this.octabularasa[new Date(key).getUTCHours()] = value;

          });

          Object.entries(this.lineWithMachine).forEach(([, value]) => {
            this.lineWithMachineHidden[value.process_cell.process_cell_name] = value.process_cell.custom_hide_view;
          });
        });

      this.isLoadingLineFact = false;
      this.global_load = false;
    },
    async updateShiftAndFetch() {
      if (this.selectedDate) {
        this.weekday = new Date(this.selectedDate).getDay(); // Update weekday dynamically

        // Automatically select the correct morning shift
        if (this.weekday <= 4) {
          this.selectedShift = this.shifts.find((shift) => shift.value === "morning");
        } else {
          this.selectedShift = this.weekendShifts.find((shift) => shift.value === "morning");
        }
        this.getCurrent(this.selectedShift);
      }
    },
    async getLogbookDetail() {
      await axios
        .get("/apiv1/" + this.idParam)
        .then((res) => {
          this.logbookDetail = res.data;
          this.processCellList(res.data);
          console.log('logbookdetail__ ', res.data);

        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * Updates a machine custom field by sending a POST request to the server.
     *
     * @param {Number} machineId - The ID of the machine.
     * @param {Object} field - The custom field object containing field details.
     * @param {Object} linefa - The logbook line fact object.
     *
     * The function sets the loading state of the field to true and error state to false.
     * It sends a POST request to the endpoint '/apiv1/mcf/mcf-fill' with the machine ID,
     * custom field type ID, logbook line fact, and the field value.
     *
     * On successful response (status 200), it sets the loading state to false and shows a success message.
     * On error, it sets the error state to true, logs the error response, and shows an error message.
     * The loading state is reset to false after 5 seconds in case of an error.
     */
    setMachineCustomField(machineId, field, linefa) {
      field.loading = true;
      field.error = false;
      axios
        .post("/apiv1/mcf/mcf-fill", {
          machine: machineId,
          machine_custom_field: field.field_type_id,
          logbook_line_fact: linefa,
          value: field.value,
        })
        .then((res) => {
          if (res.status == 200) {
            field.loading = false;
            this.sNack("Machine custom field updated", true);
          }
        })
        .catch((err) => {
          field.error = true;
          setTimeout(() => {
            field.loading = false;
          }, 5000);
          this.sNack(err.response.data, false);
          console.log(err.response.data);
        });
      
     
    },
  },

  computed: {
    /**
     * Computes the completion status for each hour in the shift.
     * Logs remaining empty custom fields that are editable.
     */
    hourlyCompletionStatus() {
      if (!this.currentShift || Object.keys(this.currentShift).length === 0) {
        return {};
      }

      let status = {};

      Object.entries(this.currentShift).forEach(([hourKey, hourData]) => {
        if (!hourData || Object.keys(hourData).length === 0) {
          status[hourKey] = "empty";
          return;
        }

        let hasEdits = false;
        let allFilled = true;

        // Iterate through each process cell in the hour
        Object.values(hourData).forEach((section) => {
          if (!section || typeof section !== "object" || !section.facts) return;
          section.facts.forEach((fact) => {
            // Check Line Custom Fields
            if (fact.custom_field_facts && Array.isArray(fact.custom_field_facts)) {
              fact.custom_field_facts.forEach((cf) => {
                // Apply "DISABLED" logic
                if (fact.logbook_line != cf.process_cell_line && cf.global_type == false) {
                  return;
                }

                if (cf.value) {
                  hasEdits = true; // At least one field has data
                } else {
                  allFilled = false; // At least one field is empty
                }
              });
            }

            // Check Machine Custom Fields
            if (fact.machines && Array.isArray(fact.machines)) {
              fact.machines.forEach((machine) => {
                if (machine.machine_facts && Array.isArray(machine.machine_facts)) {
                  machine.machine_facts.forEach((machineFact) => {
                    if (
                      machineFact.machine_custom_field_facts &&
                      Array.isArray(machineFact.machine_custom_field_facts)
                    ) {
                      machineFact.machine_custom_field_facts.forEach((mcf) => {
                        if (mcf.value) {
                          hasEdits = true;
                        } else {
                          allFilled = false;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        });

        // Assign checkbox statuses for the hour
        if (!hasEdits) {
          status[hourKey] = "empty";
        } else if (hasEdits && !allFilled) {
          status[hourKey] = "partial";
        } else {
          status[hourKey] = "full";
        }
      });

      return status;
    },
  },

  components: {},
};
</script>

<style scoped>
.logBookContent {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0px 0px 20px -15px;
}

.static-header {
  width: 11vw;
}

.navigateButtons {
  height: 55px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.v-tab {
  background-color: #f2f2f2;
}

.v-tab--selected {
  background-color: #fff;
}

.cellToEdit {
  cursor: pointer;
}

.machine-row:nth-child(even) {
  background: rgb(240, 240, 240);
}

.pc-row{
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
}

.pc-row:nth-child(odd) {
  background: rgb(240, 240, 240);
  
}

.mobileHeader {
  display: none;
}

.printMachinesFacts {
  display: none;
}

/* Add responsive styles */
@media (max-width: 768px) {
  .mobileContainer {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .machine-custom-fields {
    display: block !important;
  }

  .mobileInputs {
    width: 100% !important;
    /* padding-top: 0px;
        margin-bottom: 0px!important; */
    padding-left: 12px !important;
    padding-right: 12px !important;
    margin-bottom: 5px !important;
    display: block !important;
  }

  .bigHeader {
    display: none;
  }

  .mobileCol {
    display: unset !important;
  }

  .mobileHeader {
    display: unset;
    font-size: 16px;
  }

  .logbookMobileFilter {
    width: 50% !important;
  }

  .filters {
    width: 100% !important;
  }

  .filtersContainer {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}

@media print {
  .bigContainerToPrint {
    padding: 0px !important;
    margin-top: 10px !important;
  }

  .mobileContainer {
    margin-top: -10px !important;
    background-color: #fff;
  }

  .machine-custom-fields {
    display: none !important;
  }

  .printMachinesFacts {
    display: flex;
  }

  .noPadding {
    padding: 0px 0px 0px 5px;
  }

  .noPrint {
    display: none;
  }

  .zebra:nth-of-type(even) {
    background: rgb(240, 240, 240);
  }
}
</style>
